// src/components/Auth/RequireAuth.jsx
import React, { useContext } from 'react'
import { Navigate, useLocation, Outlet } from 'react-router-dom'
import { AuthContext } from '../../contexts/AuthContext'
import Loader from '../Utils/Loader' // opzionale

export default function RequireAuth() {
  const { user, ready } = useContext(AuthContext)
  const location = useLocation()

  if (!ready) return <Loader />   // o null

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />
  }

  return <Outlet />
}
